<div style="min-height: 100vh;overflow-y: auto;" *ngIf="coursePlayerState$ | async as coursePlayerState">        
    <div *ngFor="let page of coursePlayerState.entities | keyvalue; trackBy: trackPageId">
        <div [style.width.%]="zoomWidth">
        <img [src]="page.value.pageUrl" 
            style="z-index: 100;"
            [style.display]="coursePlayerState.selectedId == page.key ? 'block' : 'none'"
            [style.width.%]="zoomWidth"
            (pan)="onPan($event)" (tap)="onTap($event)">
        </div>
        <div class="custom-page-content" [style.display]="coursePlayerState.selectedId == page.key ? 'block' : 'none'"             
            *ngIf="page.value.content" [innerHTML]="page.value.content"></div>                    
    </div>
</div>
